import { render, staticRenderFns } from "./auction-work-navigation.vue?vue&type=template&id=6a550d6b&"
import script from "./auction-work-navigation.vue?vue&type=script&lang=js&"
export * from "./auction-work-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports